import {getAnalytics, isSupported} from 'firebase/analytics';
import {initializeApp} from 'firebase/app';
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue
} from 'firebase/remote-config';

import defaultPolicies from './configs/defaultPolicies.json';

const configHml = {
  apiKey: import.meta.env.VITE_FIREBASE_HML_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_HML_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_HML_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_HML_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_HML_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_HML_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_HML_MEASUREMENT
};

const configPrd = {
  apiKey: import.meta.env.VITE_FIREBASE_PRD_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_PRD_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PRD_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_PRD_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_PRD_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_PRD_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_PRD_MEASUREMENT
};

const hostname = window.location.hostname;
const isPrd = hostname === import.meta.env.VITE_PRD_HOST;

const firebaseConfig = isPrd ? configPrd : configHml;

const app = initializeApp(firebaseConfig);

let analytics = null;
isSupported()
  .then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  })
  .catch(() => {});

const remoteConfig = getRemoteConfig(app);

remoteConfig.settings = {
  minimumFetchIntervalMillis: isPrd ? 3600000 : 0,
  fetchTimeoutMillis: 10000
};

remoteConfig.defaultConfig = {
  maintenance_mode: false,
  feature_flags: '{}',
  recaptcha_configs: '{}',
  terms_policy_content: JSON.stringify(defaultPolicies)
};

export {app, analytics, remoteConfig, fetchAndActivate, getValue};
